import { GeoJsonLayer } from '@deck.gl/layers';

import type { LpisFeature, LpisFeatureProperties } from '../../io/lpis';

const LPIS_FILL_COLOR: [number, number, number, number] = [46, 125, 50, 120];
const LPIS_LINE_COLOR: [number, number, number, number] = [27, 94, 32, 220];
const LPIS_HIGHLIGHT_COLOR: [number, number, number, number] = [
  102,
  187,
  106,
  160,
];

interface LpisGeoJsonLayerProps {
  visible: boolean;
  features: LpisFeature[];
}

export const lpisGeoJsonLayer = ({
  visible = false,
  features,
}: LpisGeoJsonLayerProps) =>
  new GeoJsonLayer<LpisFeatureProperties>({
    id: 'lpis-geojson-layer',
    data: features,
    visible,
    pickable: true,
    stroked: true,
    filled: true,
    getFillColor: LPIS_FILL_COLOR,
    getLineColor: LPIS_LINE_COLOR,
    getLineWidth: 1,
    lineWidthUnits: 'pixels',
    highlightColor: LPIS_HIGHLIGHT_COLOR,
    autoHighlight: true,
  });
